<template>
  <div class="home bg-grey">
    <NavbarMain />
    <div class="container mt-5">
      <div class="form-group bg-light-2 p-4 border shadow-sm mt-5">
        <h4>
          Detalles por el cual sera cancelada la publicación "{{product.name}}" de
          <b
            class="text-capitalize"
          >{{product.sellerId.username}}</b>
        </h4>
        <hr />
        <textarea
          type="text"
          class="form-control"
          placeholder="Detalles..."
          rows="10"
          v-model="msgCancel"
        ></textarea>
        <span class="btn btn-block btn-primary my-3" v-show="!onLoad" @click="cancelProduct">Cancelar</span>
        <span class="btn btn-block btn-primary my-3" v-show="onLoad"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Cancelando...</span>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import Api from "../../tools/Api2";
import { mapState } from "vuex";
import Configs from "@/configs/configs";

export default {
  name: "AdminCancelService",
  data() {
    return {
      msgCancel: "",
      onLoad: false,
      product: {
        name: "",
        sellerId: {
          username: "",
        },
      },
      url: Configs.API.BASE,
    };
  },
  components: {
    NavbarMain,
  },
  methods: {
    cancelProduct() {
      this.onLoad = true;
      Api("service").patch(this.product._id , { state: 2, msgCancel: this.msgCancel }).then( () => {
        this.$router.push("/admin/services");
      });
    },
  },
  created: async function () {
    window.scrollTo(0, 0);
    Api("service").get(this.$route.params.id).then( res => {
      this.product = res.service;
    });
  },
  computed: {
    ...mapState(["auth"]),
  },
};
</script>

<style scoped>
#amount-input {
  width: 4em;
  display: inline;
}

/* number inputs with arrows always visible */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  opacity: 1;
}

.old-price {
  text-decoration: line-through;
  font-size: 0.8em;
}

.old-price div {
  margin-left: 0.5em;
  text-decoration: line-through;
  text-decoration-color: grey;
  font-size: 0.8em;
}
</style>